import { Avatar, Color, Spacing, Text, shortLocalizedDateAndTime } from 'zens-storybook'
import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useStore, useUser } from 'zens-store'
import { ErrorBoundary } from 'react-error-boundary'

const styles = StyleSheet.create({
  container: {
    marginRight: Spacing.M,
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatar: {
    marginRight: Spacing.XS,
    width: 20,
    height: 20,
  },
  date: {
    color: Color.metalGrey,
  },
})

interface Props {
  companyId: number
  activity?: 'added' | 'updated'
  userId?: number
  date?: string
}

const UserActivityFallback = (props: { activity?: 'added' | 'updated'; date?: string }) => {
  const { activity, date } = props
  const { i18n } = useStore()
  const { t } = useTranslation()

  const displayDate = date ? shortLocalizedDateAndTime(date, i18n.language, t) : ''
  return (
    <View style={styles.container}>
      <Avatar style={styles.avatar} name="?" />
      <Text style={styles.date} level={7}>
        {activity === 'updated'
          ? t('Updated {{date}}', { date: displayDate })
          : t('Added {{date}}', { date: displayDate })}
      </Text>
    </View>
  )
}

const UserActivityContent = (props: Props) => {
  const { companyId, activity, userId = 0, date } = props
  const { i18n } = useStore()
  const { t } = useTranslation()

  const createdBy = useUser({ companyId, userId })

  const displayDate = date ? shortLocalizedDateAndTime(date, i18n.language, t) : ''
  return (
    <View style={styles.container}>
      <Avatar style={styles.avatar} name={createdBy.data?.displayName} email={createdBy.data?.email} />
      <Text style={styles.date} level={7}>
        {activity === 'updated'
          ? t('Updated {{date}}', { date: displayDate })
          : t('Added {{date}}', { date: displayDate })}
      </Text>
    </View>
  )
}

const UserActivity = (props: Props) => {
  return (
    <ErrorBoundary
      fallback={<UserActivityFallback activity={props.activity} date={props.date} />}
      onError={(error) => {
        // Silently handle the error - user was likely deleted
        console.debug('User fetch failed (user may have been deleted):', error.message)
      }}
    >
      <UserActivityContent {...props} />
    </ErrorBoundary>
  )
}

export default UserActivity
